export default "__VITE_ASSET__TjeT0MKCEUx76lp9w$CFww__"